import { PackageProcessServiceBase, WsPackageProcess } from "./wsdl/WsPackageProcess/v1.04/WsPackageProcess";

export {
    WsPackageProcess
};

export class PackageProcessService extends PackageProcessServiceBase {
}
